import { debounce } from '../../../../../Convatec.Dxp.Feature.GlobalContent/WebComponents/src/components/utilities/behavior-helpers/index.js';
import { isSafari } from '../../../../../Convatec.Dxp.Feature.GlobalContent/WebComponents/src/components/utilities/dom-helpers/index.js';

const amcareSetScrollPadding = () => {
    const SAFARI_SCROLL_OFFSET = 30;
    const header = document.querySelector('amcare-main-nav');
    if (!header)
        return;
    const headerShadowRootEl = header.shadowRoot.querySelector('nav');
    document.querySelector('html').style.scrollPaddingTop = `${headerShadowRootEl.clientHeight + (isSafari ? SAFARI_SCROLL_OFFSET : 0) + 25}px`;
};
document.addEventListener('DOMContentLoaded', amcareSetScrollPadding);
window.addEventListener('resize', debounce(() => {
    amcareSetScrollPadding();
}, 100));

export { amcareSetScrollPadding };
